import { useMemo } from 'react'

import { PageLinkWithHighlightComponent } from '@dc-shared-web/components/features/Chat/ChatConversation'
import {
  encodeHighlight,
  SerializableHighlight,
} from '@dc-shared-web/lib/highlightSerializer'
import { ChatCitationMap } from '@dc-shared-web/providers'
import { getCitationHighlights } from '@dc-shared-web/lib/citationHelpers'
import { Icon } from '@dc-shared-web/components'
import { faHighlighterLine } from '@document-crunch/pro-regular-svg-icons'

const getEncodedHighlightsWithPage = (highlights: SerializableHighlight[]) => {
  if (highlights.length === 0)
    return { encodedHighlights: undefined, page: undefined }

  const page = highlights.reduce(
    (acc, highlight) => Math.min(acc, highlight.page),
    Infinity
  )

  return {
    encodedHighlights: encodeHighlight(highlights),
    page,
  }
}

const createCitationComponent = (
  Link: PageLinkWithHighlightComponent,
  citations?: ChatCitationMap
) => {
  const Component = ({ id }: { id: number }) => {
    const citation = citations?.[id]
    // eslint-disable-next-line prefer-const
    let { encodedHighlights, page: highlightsPage } = useMemo(() => {
      if (!citation) return { encodedHighlights: undefined, page: undefined }

      const highlights = getCitationHighlights(citation)
      return getEncodedHighlightsWithPage(highlights)
    }, [citation])

    if (!highlightsPage) {
      if (citation?.page) {
        highlightsPage = citation.page
      } else {
        return null
      }
    }

    if (!encodedHighlights) {
      // TODO: Use Rollbar when we wanted to be notified of this.
      console.warn('No encoded highlights found for citation', { id, citation })
      return <Link page={highlightsPage}>Page {highlightsPage}</Link>
    }

    return (
      <Link page={highlightsPage} highlight={encodedHighlights}>
        <Icon
          icon={faHighlighterLine}
          size='sm'
          className='tw-text-blue-600 [display:inline-block!important] tw-w-auto'
        />{' '}
        Page {highlightsPage}
      </Link>
    )
  }

  Component.displayName = 'CitationComponent'

  return Component
}

export default createCitationComponent
